import { Helmet } from 'react-helmet-async';

import { View500 } from 'src/sections/error';

// ----------------------------------------------------------------------

export default function Page500() {
  return (
    <>
      <Helmet>
        <title>HeyJob - Errore interno</title>
      </Helmet>

      <View500 />
    </>
  );
}
